import { render, staticRenderFns } from "./DownloadEndorsements.vue?vue&type=template&id=50dc2ef4&"
import script from "./DownloadEndorsements.vue?vue&type=script&lang=js&"
export * from "./DownloadEndorsements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports